import classNames from 'classnames';
import React from 'react';

/**
 * The platform's name, drawn the way DeepHealth draws its own: lower case, "deep" light and the product
 * bold. Text, not an image — it takes the colour and size of where it sits.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={classNames('font-dh tracking-tight', className)}>
      <span className="sr-only">deeplabeling</span>
      <span aria-hidden className="font-light">
        deep
      </span>
      <span aria-hidden className="font-bold">
        labeling
      </span>
    </span>
  );
}

export default Wordmark;
